// 챗봇 운영 설정: 코드값 ↔ 시안 글자(계약 §12 표), 카테고리 줄 변환

export const HOURS = [["24/7", "연중무휴 24시간"], ["business", "평일 09:00-18:00"], ["extended", "평일 08:00-22:00"]];
export const SESSIONS = [["30", "30분"], ["60", "1시간"], ["120", "2시간"], ["unlimited", "무제한"]];
export const MAX_MESSAGES = [["10", "10개"], ["30", "30개"], ["50", "50개"], ["unlimited", "제한 없음"]];

export const EMOJIS = ["🖥️", "📱", "💳", "🔧", "💻", "🖨️", "🌐", "💡", "📊", "📋", "📈", "🎯", "🏆", "⭐", "🚀", "🔒", "📞", "💬"];

export const HANDOFF = "handoff";
export const HANDOFF_LABEL = "담당자 배정 (상담원 연결)";
export const NEW_ROW_MAP = "etc|other"; // 시안: 새 카테고리는 기타문의 · 기타

const FIELDS = ["welcome_title", "welcome_message", "welcome_title_zh", "welcome_message_zh", "emergency_phone", "emergency_email"];
const DEFAULT_CHOICES = { operating_hours: "24/7", session_duration: "30", max_messages: "30" };

export function settingForm(s) {
    const src = s || {};
    const f = Object.fromEntries(FIELDS.map((k) => [k, src[k] ?? ""]));
    Object.entries(DEFAULT_CHOICES).forEach(([k, d]) => { f[k] = src[k] ?? d; });
    return f;
}

// 선택 목록 = 상담원 연결 + meta.categories 를 펼친 것
export function mapOptions(meta) {
    const opts = [{ value: HANDOFF, label: HANDOFF_LABEL }];
    (meta?.categories || []).forEach((c) =>
        (c.subcategories || []).forEach((s) => opts.push({ value: `${c.code}|${s.code}`, label: `${c.label} · ${s.label}` })));
    return opts;
}

export function mapValue(m) {
    if (!m) return "";
    if (m.mode === HANDOFF) return HANDOFF;
    return m.category_code && m.subcategory_code ? `${m.category_code}|${m.subcategory_code}` : "";
}

export function toInquiryMap(v) {
    if (v === HANDOFF) return { mode: HANDOFF };
    if (!v) return { mode: "fixed" };
    const [category_code, subcategory_code] = v.split("|");
    return { mode: "fixed", category_code, subcategory_code };
}

let seq = 0;
const key = () => `r${++seq}`;

export const toRow = (c) => ({
    _k: key(), id: c.id, icon: c.icon_emoji || "📋", name: c.name || "", desc: c.description || "",
    nameZh: c.name_zh || "", descZh: c.description_zh || "", map: mapValue(c.inquiry_map),
});

export const newRow = () => ({ _k: key(), icon: "📋", name: "", desc: "", nameZh: "", descZh: "", map: NEW_ROW_MAP });

// 중국어 칸은 null 이 '변경 없음'이라 지울 때 빈 문자열로 보낸다(백엔드 schemas/system.py)
export function toPayload(r) {
    const out = {
        icon_emoji: r.icon, name: r.name.trim(), description: r.desc,
        name_zh: r.nameZh, description_zh: r.descZh, inquiry_map: toInquiryMap(r.map),
    };
    return r.id ? { id: r.id, ...out } : out;
}

export const move = (list, i, d) => {
    const j = i + d;
    if (j < 0 || j >= list.length) return list;
    const next = list.slice();
    [next[i], next[j]] = [next[j], next[i]];
    return next;
};
